import * as React from 'react'
import styled from 'styled-components'

import { TagList } from '@boutique/components'
import * as entity from '@boutique/entities'

import * as plume from '@ulule/owl-kit-components/next'

export function TagDiscover({ product }: { product: entity.product.Product }) {
  return (
    <Wrapper>
      <plume.styles.heading.XXXS as="h3">Découvrez d'autres produits similaires :</plume.styles.heading.XXXS>
      <plume.styles.heading.XXXS>{product.title}</plume.styles.heading.XXXS>
      <StyledTagList tagList={product.tags} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: 48px;
`
const StyledTagList = styled(TagList)`
  margin-top: 20px;
`
